import { ToastrService } from "ngx-toastr";
import { wsService } from "../services/ws.service";
import { log } from "./logging";
import { StatusEvent } from "../interfaces/Logs.interface";
import { getUTCDateObj } from "./timeManager";
import { TrsEventsService } from "../services/trsevents.service";
import { LogUpload } from "./log-upload";
import { TranslocoService } from "@ngneat/transloco";

let isOpenInAnotherTab: boolean = false;
const channel: BroadcastChannel = new BroadcastChannel("___swfh_supervisor_ui");

channel.onmessage = (event) => {
    if (event.data === "___isOpenInAnotherTab")
        channel.postMessage("___isOpenInAnotherTab___true");
    else if (event.data === "___isOpenInAnotherTab___true")
        isOpenInAnotherTab = true;
    else if (event.data === "___isOpenInAnotherTab___false") {
        isOpenInAnotherTab = false;
        channel.postMessage("___isOpenInAnotherTab");
    }
}

channel.postMessage("___isOpenInAnotherTab");

export const isExistingLoginAvailable = (websocketServiceRef: wsService, toastServiceRef: ToastrService, eventsServiceRef: TrsEventsService, translationServiceRef: TranslocoService, considerPageReloads: boolean): boolean => {
    const data: StatusEvent = {
        SummaryId: websocketServiceRef.traceId,
        Status: "",
        Reason: "",
        StatusDateTime: getUTCDateObj(),
    };
    const logUploader: LogUpload = new LogUpload("login");

    if (window.name != null && window.name !== "") {
        const lanId: string = websocketServiceRef.getSupervisorId();
        window.localStorage.setItem("AgentLanId", lanId);

        if (considerPageReloads == true) {
            //this will occur when the supervisor has logged in one tab and tries to load another tab (very rare)
            return false;
        }
        else {
            //this will occur when the supervisor has logged in one tab and tries to click the login button
            data.Reason = "Supervisor already logged in";
            data.Status = "Success";
            eventsServiceRef.UploadMilestoneStatus(data);

            toastServiceRef.warning(translationServiceRef.translate("A supervisor has already logged in this browser. Please logout and continue."));

            logUploader.warn("isExistingLoginAvailable", `Supervisor already logged in ${eventsServiceRef.supervisorId}`);
            log.warn(`Supervisor already logged in ${eventsServiceRef.supervisorId}`);

            return true;
        }
    }
    else {
        //this will occur when the supervisor has logged in one tab and tries to load another tab
        //Another scenario is when the supervisor is logged in and suddenly shuts down the system without logging out, localstorage will not be cleared
        const agentLanId: string | null = window.localStorage.getItem("AgentLanId");

        if (agentLanId != null && agentLanId !== "") {
            if (isOpenInAnotherTab === true) {
                log.warn(`localStorage item AgentLanId (${agentLanId}) is present, considering this page to be duplicate.`)
                toastServiceRef.warning(translationServiceRef.translate("A supervisor has already logged in this browser. Please logout and continue."));
                return true;
            }

            const lastHearbeat: string | null = window.localStorage.getItem("___lastHeartbeatAck");

            if (lastHearbeat == null || lastHearbeat === "" || Number(lastHearbeat) === 0 || Number.isNaN(Number(lastHearbeat)) === true) {
                //This scenario will never occur since the heartbeat ack is received every 15sec when the supervisor is logged in
                log.info(`LastHeartbeat ack (${lastHearbeat}) is null or empty or 0 or NaN, this is not possible when supervisor is logged in`);
                return false;
            }
            else {
                const lastHeartbeatTime: number = Number(lastHearbeat);
                const currentTime: number = new Date().getTime();
                const timeDiff: number = currentTime - lastHeartbeatTime;

                log.info(`Last heartbeat ack time: ${lastHeartbeatTime}, Current time: ${currentTime}, Time diff: ${timeDiff}`);

                if (timeDiff > 1000 * 60 * 1) {
                    //This means that it has been more than 1 minute since the last heartbeat ack was received i.e. the supervisor has not logged out properly
                    log.info(`Removing AgentLanId (${agentLanId}) from localstorage as it has been more than 1 minute since the last heartbeat ack was received`);
                    window.localStorage.removeItem("AgentLanId");
                    return false;
                }
                else {
                    //This scenario should not occur, since its not possible for the existing login check to be called with a heartbeat ack time of less than 1 minute
                    log.info(`Not doing anything for AgentLanId (${agentLanId}) as the last heartbeat ack was received within 1 minute`);   
                    return false;
                }
            }
        }
        else {
            log.info("New login");
            return false;
        }
    }
}

export const closeBroadcastChannel = (): void => {
    if (channel != null) {
        channel.postMessage("___isOpenInAnotherTab___false");
        channel.close();
    }
}

export const checkIfBroadcastChannelIsOpen = (): boolean => channel != null; 